document.addEventListener("DOMContentLoaded", function () {
    // PLP perf: Swipers are tracked so they can be destroyed once Nosto / facets / recommendations replace their markup.
    // Previously reinitializeSwipers() only saw containers still in the document, so instances on replaced cards (e.g.
    // the hidden server-rendered cards Nosto replaces) were never destroyed and kept the old card trees in memory. It
    // also destroyed and rebuilt every connected Swiper on each event; now only new containers are initialized.
    // Swipers are still created as soon as the cards are inserted, as before: creating them only when a card nears the
    // viewport made Lighthouse take the first product image as the LCP element (~20-30 s simulated on mobile, since
    // that image depends on Nosto) instead of an earlier element (~5 s).
    const instances = new Set();

    // PLP perf (TBT / Speed Index): server-rendered cards of the Nosto PLP stay display:none until Nosto replaces them
    // (nosto-collection.css). Building their loop Swipers at DOMContentLoaded forced ~280 style recalculations for
    // carousels that are never shown. If the native fallback shows them instead, showFallbackContent() in
    // nosto-collection.js dispatches collection-rendred and they are created then.
    const HIDDEN_NOSTO_SERVER_CARD = '#main:not(.nosto-loaded):not(.nosto-fallback) product-list[is-nosto-collection] product-card:not([is-nosto-product])';

    function updateActiveBullet(swiperInstance) {
        const paginationEl = swiperInstance.pagination.el;
        const paginationBullets = paginationEl ? paginationEl.querySelectorAll('.swiper-pagination-bullet') : null;

        if (paginationBullets) {
            paginationBullets.forEach((bullet) => bullet.classList.remove('swiper-pagination-bullet-active'));

            const realIndex = swiperInstance.realIndex + 1;
            const activeBullet = paginationEl.querySelector(`.swiper-pagination-bullet:nth-child(${realIndex})`);
            if (activeBullet) {
                activeBullet.classList.add('swiper-pagination-bullet-active');
            }
        }
    }

    // Slides after the first render their image with data-src/data-srcset (snippets/product-card.liquid) so the browser
    // does not download every photo of every card. They are promoted on the user's first pointerdown on the carousel
    // (swipe or pagination bullet), which fires before the slide moves. Swiper events are not used for this: loop mode
    // repositions slides by itself (init, updates after images load) and emits slideChange without any user action.
    function loadSlideImages(carousel) {
        carousel.querySelectorAll('.swiper-slide').forEach((slide) => {
            slide.querySelectorAll('img[data-src], img[data-srcset]').forEach((img) => {
                if (img.dataset.srcset) {
                    img.srcset = img.dataset.srcset;
                    img.removeAttribute('data-srcset');
                }
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                }
            });
        });
    }

    function createSwiper(carousel) {
        if (carousel.swiperInstance) return;

        const swiper = new Swiper(carousel, {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: carousel.querySelector('.swiper-pagination'),
                clickable: true,
            },
            on: {
                slideChange: function () {
                    updateActiveBullet(this);
                },
            },
        });
        carousel.addEventListener('pointerdown', () => loadSlideImages(carousel), { once: true });
        carousel.swiperInstance = swiper;
        instances.add(swiper);
    }

    function initializeSwipers() {
        if (window.innerWidth > 991) return;

        document.querySelectorAll('.swiper-container').forEach((carousel) => {
            if (!carousel.closest(HIDDEN_NOSTO_SERVER_CARD)) createSwiper(carousel);
        });
    }

    function releaseDetachedSwipers() {
        instances.forEach((swiper) => {
            if (swiper.el && swiper.el.isConnected) return;
            if (swiper.el) swiper.el.swiperInstance = null;
            swiper.destroy(true, true);
            instances.delete(swiper);
        });
    }

    // Used by the product card sibling swatch. Swapping slides on a live loop Swiper (removeAllSlides, then
    // appendSlide one slide at a time) rebuilt the loop and the layout for every slide, and logged
    // "not enough slides for loop mode" warnings while the slider was emptied. Rebuild it once instead.
    window.replaceCardSwiperSlides = function (carousel, slides) {
        const swiper = carousel.swiperInstance;
        if (swiper) {
            instances.delete(swiper);
            carousel.swiperInstance = null;
            swiper.destroy(true, true);
        }
        carousel.querySelector('.swiper-wrapper').replaceChildren(...slides);
        createSwiper(carousel);
    };

    function reinitializeSwipers() {
        releaseDetachedSwipers();
        initializeSwipers();
    }

    initializeSwipers();

    document.addEventListener('collection-rendred', reinitializeSwipers);
    document.addEventListener('recommendation-rendred', reinitializeSwipers);
});
